module.exports = __webpack_public_path__ + "SamsungOne-450.6988e0f337aaeedcb34c.ttf";


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/assets/layout/fonts/SamsungOne-450.ttf
// module id = ../../../../../src/assets/layout/fonts/SamsungOne-450.ttf
// module chunks = styles